package com.wintermar.inspection.feature.presentation.template.widget.preview

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun PageFooter(
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color
) {
    Spacer(
        modifier = Modifier
            .fillMaxWidth()
            .height(dimension.spacing.space4)
            .background(
                color = color.surface.neutral.subtle.default,
                shape = RoundedCornerShape(
                    bottomStart = dimension.radius.lg,
                    bottomEnd = dimension.radius.lg
                )
            )
            .testTag("page_footer_spacer_top")
    )
    Spacer(
        modifier = Modifier.height(dimension.spacing.space4)
            .testTag("page_footer_spacer_bottom")
    )
}
